/** Microseconds since Unix epoch. 53-bit safe in a JS number until year ~2255. */
export type Instant = number;
/** Duration in microseconds. */
export type Micros = number;

export interface TimerHandle {
  /** Idempotent. A cancelled timer never fires. */
  cancel(): void;
}

/** ADR-13 Clock. Every "what time is it", every scheduled action, every event id. */
export interface Clock {
  now(): Instant;
  after(d: Micros, cb: () => void): TimerHandle;
  at(t: Instant, cb: () => void): TimerHandle;
  tid(): string;
}

/** simd-published clock state (ADR-13 Bindings). */
export interface ClockState {
  anchorSim: Instant;
  anchorMono: number;
  rate: number; // 0..60
  generation: number;
}

export class CascadeBudgetError extends Error {
  constructor(public readonly firedCount: number, public readonly haltedAt: Instant) {
    super(`spanReplay cascade budget exhausted after ${firedCount} firings at ${haltedAt}`);
    this.name = "CascadeBudgetError";
  }
}
